import React from 'react'

import { Text, TextStyles } from '@cinch-labs/design-system'
import VehicleCard from '@cinch/oxd-components/vehicle-card/src'
import { VehicleSearchService } from '@cinch/oxd-utils/requests/src'

import * as styles from './manufacturer-vehicles.module.css'

interface VehicleProps {
  car: VehicleSearchService.Car
  title: string
  i18n: Cinch.WebAppTranslations['manufacturer']
  onVehiclesAvailability: (areAvailable: boolean) => any
}

const Vehicles: React.FC<VehicleProps> = ({ car, title, i18n, onVehiclesAvailability }) => {
  const holdingArr = new Array(6).fill(null)
  const [vehicles, updateVehicles] = React.useState<Cinch.DirectVehicleAdvertSummary[]>(holdingArr)

  const getVehicles = async () => {
    const req = await VehicleSearchService.getVehiclesByMakeAndModel(car)
    updateVehicles(req.data.vehicleListings)
  }

  React.useEffect(() => {
    getVehicles()
  }, [car])

  React.useEffect(() => {
    if (vehicles) {
      onVehiclesAvailability(!!vehicles.length)
    }
  }, [vehicles])

  const mapVehiclesToCards = (vehicles: Cinch.DirectVehicleAdvertSummary[]) => {
    const cards = vehicles.map((vehicle, index) => {
      const props = vehicle ? { isPending: false, vehicle } : { isPending: true }

      return (
        <div key={index} className={styles.vehicle} data-testid="manufacturer-vehicle">
          <VehicleCard isSaved={false} isAvailable={true} {...props} />
        </div>
      )
    })

    if (cards.length % 3 == 2) {
      // add a blank card to fix layout bug when there are only 2 out of 3 cards in a row
      cards.push(<div key={cards.length} className={styles.vehicle}></div>)
    }

    return cards
  }

  return (
    <div className={styles.vehicles}>
      <Text oxford={true} className={styles.title} element={'h3'} type={TextStyles.vehicleSubTitle}>
        {i18n.forSale.replace('{placeholder}', title)}
      </Text>
      <div className={styles.content}>
        {!!vehicles && !!vehicles.length && mapVehiclesToCards(vehicles)}
        {!!vehicles && !vehicles.length && (
          <Text oxford={true} element={'p'} type={TextStyles.body1}>
            {i18n.unavailable.replace('{placeholder}', title)}
          </Text>
        )}
      </div>
    </div>
  )
}

export default Vehicles
